export enum ShiftErrorMessages {
  NoName = 'Please enter a name for your shift.',
  InvalidStartTime = 'Please enter a valid starting time in the following format hh:mm.',
  InvalidEndTime = 'Please enter a valid ending time in the following format hh:mm.',
  // tslint:disable-next-line:max-line-length
  OverLappingShift = 'Overlapping shifts are found. Please adjust your starting and ending time so that it does not overlap any existing shifts.',
  NoError = ''
}
